// src/features/fourlink-config/components/shared/ProgressBar.jsx

import React from 'react';

export const ProgressBar = ({ currentBlock, currentStep, maxSteps }) => {
  const progress = ((currentBlock - 1) * 50) + ((currentStep / maxSteps) * 50);

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 mb-8">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <span className="text-sm font-semibold" style={{ color: '#1a365d' }}>
            Bloque {currentBlock}: {currentBlock === 1 ? 'Selección de ítems' : 'Matrices y Configuración'}
          </span>
          <span className="text-sm text-gray-500">
            (Paso {currentStep} de {maxSteps})
          </span>
        </div>
      </div>
      
      <div className="w-full bg-gray-200 rounded-full h-3">
        <div
          className="h-3 rounded-full transition-all duration-500"
          style={{ 
            width: `${progress}%`,
            backgroundColor: '#3182ce'
          }}
        />
      </div>
    </div>
  );
};